import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-one-dual",
  templateUrl: "./axle-one-dual.component.html",
  styleUrls: ["./axle-one-dual.component.scss"],
})
export class AxleOneDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorOneIntLeftSelect: any = [];
  public sensorOneIntRightSelect: any = [];

  public sensorOneExtLeftSelect: any = [];
  public sensorOneExtRightSelect: any = [];

  public sensorOneIntRightCombo: any = [];
  public sensorOneIntLeftCombo: any = [];

  public sensorOneExtRightCombo: any = [];
  public sensorOneExtLeftCombo: any = [];

  public axisOneDoubleLeftIntForm: FormGroup;
  public axisOneDoubleLeftExtForm: FormGroup;

  public axisOneDoubleRightIntForm: FormGroup;
  public axisOneDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorOneIntRightCombo = [];
      this.sensorOneExtRightCombo = [];
      this.sensorOneIntLeftCombo = [];
      this.sensorOneExtLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorOneIntRightCombo.push(element);
          this.sensorOneExtRightCombo.push(element);
          this.sensorOneIntLeftCombo.push(element);
          this.sensorOneExtLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });

    this.axisOneDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisOneDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorOneExtRightCombo.push(element);
        this.sensorOneExtLeftCombo.push(element);
        this.sensorOneIntRightCombo.push(element);
        this.sensorOneIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisOneDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 ESQ INT"
      );
      this.axisOneDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 ESQ EXT"
      );

      this.axisOneDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 DIR INT"
      );
      this.axisOneDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 1 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo1DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          4
        );
        const eixo1EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          3
        );
        const eixo1DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          20
        );
        const eixo1EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          19
        );

        // EIXO 1 DIREITO EXTERNO
        if (eixo1DireitoExt != null) {
          this.axisOneDoubleRightExtForm.controls["id"].setValue(
            eixo1DireitoExt.id
          );

          if (eixo1DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorOneExtRightCombo, eixo1DireitoExt.sensor);
            this.sensorOneExtRightSelect = eixo1DireitoExt.sensor.id;
          }

          if (eixo1DireitoExt.pneu != null) {
            this.axisOneDoubleRightExtForm.controls["pneu"].setValue(
              eixo1DireitoExt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo1DireitoExt.nrPressaoMinima
          );

          this.axisOneDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo1DireitoExt.nrPressaoMaxima
          );

          this.axisOneDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 1 ESQ EXT
        if (eixo1EsquerdoExt != null) {
          this.axisOneDoubleLeftExtForm.controls["id"].setValue(
            eixo1EsquerdoExt.id
          );

          if (eixo1EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorOneExtLeftCombo, eixo1EsquerdoExt.sensor);
            this.sensorOneExtLeftSelect = eixo1EsquerdoExt.sensor.id;
          }

          if (eixo1EsquerdoExt.pneu != null) {
            this.axisOneDoubleLeftExtForm.controls["pneu"].setValue(
              eixo1EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo1EsquerdoExt.nrPressaoMinima
          );

          this.axisOneDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo1EsquerdoExt.nrPressaoMaxima
          );

          this.axisOneDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 1 DIREITO INTERNO
        if (eixo1DireitoInt != null) {
          this.axisOneDoubleRightIntForm.controls["id"].setValue(
            eixo1DireitoInt.id
          );

          if (eixo1DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorOneIntRightCombo, eixo1DireitoInt.sensor);
            this.sensorOneIntRightSelect = eixo1DireitoInt.sensor.id;
          }

          if (eixo1DireitoInt.pneu != null) {
            this.axisOneDoubleRightIntForm.controls["pneu"].setValue(
              eixo1DireitoInt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo1DireitoInt.nrPressaoMinima
          );

          this.axisOneDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo1DireitoInt.nrPressaoMaxima
          );

          this.axisOneDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 1 ESQ INT
        if (eixo1EsquerdoInt != null) {
          this.axisOneDoubleLeftIntForm.controls["id"].setValue(
            eixo1EsquerdoInt.id
          );

          if (eixo1EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorOneIntLeftCombo, eixo1EsquerdoInt.sensor);
            this.sensorOneIntLeftSelect = eixo1EsquerdoInt.sensor.id;
          }

          if (eixo1EsquerdoInt.pneu != null) {
            this.axisOneDoubleLeftIntForm.controls["pneu"].setValue(
              eixo1EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisOneDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo1EsquerdoInt.nrPressaoMinima
          );

          this.axisOneDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo1EsquerdoInt.nrPressaoMaxima
          );

          this.axisOneDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo1EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var axisOneArray: any = [];
      var posicoesPneusList: any = [];

      axisOneArray.push(this.axisOneDoubleLeftIntForm.value);
      axisOneArray.push(this.axisOneDoubleLeftExtForm.value);
      axisOneArray.push(this.axisOneDoubleRightExtForm.value);
      axisOneArray.push(this.axisOneDoubleRightIntForm.value);

      if (axisOneArray.length > 0) {
        axisOneArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisOneDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisOneDoubleLeftIntForm.get("id").setValue("");
      this.axisOneDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisOneDoubleLeftExtForm.get("id").setValue("");
      this.axisOneDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisOneDoubleRightExtForm.get("id").setValue("");
      this.axisOneDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisOneDoubleRightIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var axisOneArray: any = [];

      axisOneArray.push(this.axisOneDoubleLeftIntForm.value);
      axisOneArray.push(this.axisOneDoubleLeftExtForm.value);
      axisOneArray.push(this.axisOneDoubleRightExtForm.value);
      axisOneArray.push(this.axisOneDoubleRightIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(axisOneArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (axisOneArray.length > 0 && this.verificarDuplicados(axisOneArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    axisOneArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 1 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 1 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
